import { createFileRoute } from "@tanstack/react-router";
import LansareUtilaje from "@/pages/LansareUtilaje";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/lansare-utilaje/")({
  head: () => routeHead("/lansare-utilaje/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <LansareUtilaje />
  );
}
